<mat-card class="access-denied-card">
  <mat-card-header>
    <mat-icon mat-card-avatar>lock</mat-icon>
    <mat-card-title>{{ title }}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="message">{{ message }}</div>
    <div class="details" *ngIf="details">{{ details }}</div>
  </mat-card-content>
</mat-card>
